import { useRef } from "react";
import { useNavigate } from "react-router-dom";

import { Button } from "common/components/ui/Button";
import useInvitationMutations from "common/datahooks/useInvitationMutations";
import type { Invitation } from "common/types";

import InvitationImage from "assets/images/invitation.png";

interface WorkspaceInvitationProps {
  invitation: Invitation | undefined;
}

export default function InvitationDetails({
  invitation,
}: WorkspaceInvitationProps) {
  const navigate = useNavigate();
  const isAcceptRef = useRef<boolean>();
  const { respondToInvitation, isRespondingToInvitation } =
    useInvitationMutations();

  function acceptInvite() {
    isAcceptRef.current = true;
    respondToInvitation({ accept: true, memberToken: invitation.token }).then(
      () => navigate(`/workspaces/${invitation.workspace_id}`),
    );
  }

  function declineInvite() {
    isAcceptRef.current = false;
    respondToInvitation({ accept: false, memberToken: invitation.token }).then(
      () => navigate("/"),
    );
  }

  return (
    <section className="mx-auto flex max-w-[520px] grow flex-col justify-center">
      <img
        width={364}
        height={254}
        src={InvitationImage}
        alt="Aimfox Workspace Invitation"
        className="mx-auto mb-6"
      />

      <h2 className="mb-2 text-center text-2xl-bold">
        Join{" "}
        <span className="text-purple-600">{invitation.workspace_name}</span> on
        Aimfox
      </h2>

      <p className="text-center text-black-500 mb-12">
        You were invited to join the Aimfox workspace{" "}
        <span className="text-sm-bold text-black-950">
          {invitation.workspace_name}
        </span>
        . Join now to start collaborating!
      </p>

      <div className="flex flex-col-reverse gap-2.5 lg:flex-row">
        <Button
          variant="secondary-black"
          className="flex-1"
          size="lg"
          onClick={declineInvite}
          isLoading={isAcceptRef.current === false && isRespondingToInvitation}
          disabled={isAcceptRef.current === true && isRespondingToInvitation}
        >
          Decline
        </Button>

        <Button
          className="flex-1"
          size="lg"
          onClick={acceptInvite}
          isLoading={isAcceptRef.current === true && isRespondingToInvitation}
          disabled={isAcceptRef.current === false && isRespondingToInvitation}
        >
          Accept
        </Button>
      </div>
    </section>
  );
}
